import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import "./firebase/firebase";
import {firebase} from "./firebase/firebase";
import Store_Config from "./stores/Store_Config";
import * as serviceWorker from './serviceWorker';
import Application_Routes, {history} from "./routes/Application_Routes";
import {Refresh_Local_Transaction_Data_With_Firebase} from "./actions/Transaction";
import {login, logout} from "./actions/Auth";

const store = Store_Config();

// The refresh local database should run only one time because since data just need to be fetched from the database in the beginning
// At later, all the data will be synced between the database server and the local database
// Therefore, no need to run the refresh function again

const jsx = (
    <Provider store={store}>
        <Application_Routes/>
    </Provider>
);

let hasRendered = false;
const renderApplication = () => {
    if (!hasRendered) {
        ReactDOM.render(jsx, document.getElementById("root"));
        hasRendered = true;
    }
};

firebase.auth().onAuthStateChanged((user) => {
   if (user) {
       store.dispatch(login(user.uid));
       store.dispatch(Refresh_Local_Transaction_Data_With_Firebase()).then(() => {
           renderApplication();
           if (history.location.pathname === "/") {
               history.push("/dashboard");
           }
       })
   } else {
       store.dispatch(logout());
       renderApplication();
       history.push("/");
   }
});

serviceWorker.unregister();